"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.std_deviation = void 0;
var mean_1 = require("./mean");
var sum_1 = require("./sum");
var std_deviation = function (n_array) {
    var n_mean = mean_1.default(n_array);
    return Math.sqrt(sum_1.default(n_array.map(function (n) { return Math.pow(Math.abs(n - n_mean), 2); })) / n_array.length);
};
exports.std_deviation = std_deviation;
exports.default = exports.std_deviation;
